import { useEffect, useRef, useState } from 'react';

// https://github.com/spaciecat/react-hooks-series/blob/master/src/useHover.js
// We modify this using the exitTriggered value to prevent infinite re-rendering
// on mobile, since mouseenter event is triggered on touch but mouseexit is never
// triggered
export const useHover = (delay = 250) => {
  // Reference to the element we're listen for events from
  const ref = useRef();

  // Hover state management
  const [hovered, setHovered] = useState(false);
  const [exitTriggered, setExitTriggered] = useState(false);

  const timer = useRef(null);

  // Event handlers
  /* eslint-disable react-hooks/exhaustive-deps */
  const enter = () => {
    timer.current = setTimeout(() => {
      setHovered(true), (timer.current = null);
    }, delay);
  };
  /* eslint-enable react-hooks/exhaustive-deps */

  const leave = () => {
    if (timer.current) {
      clearTimeout(timer.current);
      timer.current = null;
    }
    setExitTriggered(true);
    setHovered(false);
  };

  // Simple effect, just bind and unbind the event handlers
  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    //capture ref to `current` because `ref.current`
    //is sometimes not available when returned clean fn is executed
    const nodeWithHandlersToCleanup = ref.current;
    nodeWithHandlersToCleanup?.addEventListener('mouseenter', enter);
    nodeWithHandlersToCleanup?.addEventListener('mouseleave', leave);
    return () => {
      nodeWithHandlersToCleanup?.removeEventListener('mouseenter', enter);
      nodeWithHandlersToCleanup?.removeEventListener('mouseleave', leave);
    };
  }, [enter, ref]);
  /* eslint-enable react-hooks/exhaustive-deps */

  return [ref, hovered, exitTriggered];
};
